import React, { useEffect, useState } from "react";
import classes from './ThreeWayMatching.module.css';
import axios from "axios";
import Dbutton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import ThreeWayMatchTable from "../ThreeWayMatching/purchaseorder";
import { API_ENDPOINT } from "../../../services/api/resources";
import { useSelector } from "react-redux";
import { Autocomplete, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import DButtonOutlined from "../../../components/Dashboard/DashboardButtons/dButtonOutlined";


const ItemVendorMap = () => {

    const loginData = useSelector((state) => state.loginData.value);
    const [auth_token] = useState(loginData?.auth_token);


    const [getitem, setItem] = useState([])
    const [getcategory, setCategory] = useState([])
    const [getvendor, setVendor] = useState([])

    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedcategory, setSelectedCategory] = useState(null);

    const [selectedVendor, setSelectedVendor] = useState(null);

    const [selectedvendorcategory, setSelectedVendorCategory] = useState([]);

    const [itemCode, setItemCode] = useState("");

    const [itemTable, setItemTable] = useState([]);
    const [selectedItemFromTable, setSelectedItemFromTable] = useState(null);
    const [itemNameFromTable, setItemNameFromTable] = useState("");

    const [categoryFromItemTable, setCategoryFromItemTable] = useState("");

    const [mappedVendors, setMappedVendors] = useState([]);





    const fetchVendorData = async () => {
        try {
            const response = await axios({
                url: `${API_ENDPOINT.get_all_vendor}`,
                method: "POST",
                headers: {
                    Authorization: `Bearer ${auth_token}`,
                },
            });

            console.log(response.data)
            setVendor(response?.data)
        } catch (error) {
            console.error("Error fetching RFQs:", error);

        }
    }

    const fetchItemData = async () => {
        try {
            const response = await axios({
                url: `${API_ENDPOINT.get_all_Items}`,
                method: "POST",
                headers: {
                    Authorization: `Bearer ${auth_token}`,
                },
            });

            console.log(response)
            setItem(response?.data)
        } catch (error) {
            console.error("Error fetching RFQs:", error);

        }
    }

    const fetchCategoryData = async () => {
        try {
            const response = await axios({
                url: `${API_ENDPOINT.get_all_category}`,
                method: "POST",
                headers: {
                    Authorization: `Bearer ${auth_token}`,
                },
            });

            console.log(response)
            setCategory(response?.data)
        } catch (error) {
            console.error("Error fetching RFQs:", error);

        }
    }

    const get_all_Items_table = async () => {
        try {
            const response = await axios({
                url: `${API_ENDPOINT.get_all_Items_table}`,
                method: "POST",
                headers: {
                    Authorization: `Bearer ${auth_token}`,
                },
            });

            console.log(response)
            setItemTable(response?.data || []);
        } catch (error) {
            console.error("Error fetching RFQs:", error);

        }
    }



    useEffect(() => {
        fetchVendorData()
        fetchItemData()
        fetchCategoryData()
        get_all_Items_table()
    }, [])




    const handleSaveItem = async () => {
        if (!selectedItem || !selectedcategory || !itemCode) {
            alert("Please select item, category, and enter item code.");
            return;
        }

        const payload = {
            item_name: selectedItem.item_name,
            category_token: selectedcategory.token,
            item_code: itemCode
        };

        try {
            const res = await axios.post(`${API_ENDPOINT.save_item_entry}`, payload, {
                headers: { Authorization: `Bearer ${auth_token}` },
            });
            console.log("Item saved:", res.data);
            alert("Item mapping saved successfully.");
        } catch (err) {
            console.error("Error saving item:", err);
            alert("Failed to save item mapping.");
        }
    };

    const handleSaveVendor = async () => {
        if (!selectedVendor || !selectedvendorcategory) {
            alert("Please select vendor and category.");
            return;
        }

        const payload = {
            vendor_token: selectedVendor.token,
            category_tokens: selectedvendorcategory.map((cat) => cat.token),
        };

        try {
            const res = await axios.post(`${API_ENDPOINT.save_vendor_mapping}`, payload, {
                headers: { Authorization: `Bearer ${auth_token}` },
            });
            console.log("Vendor saved:", res.data);
            alert("Vendor mapping saved successfully.");
        } catch (err) {
            console.error("Error saving vendor:", err);
            alert("Failed to save vendor mapping.");
        }
    };


    const handleFetchVendors = async (itemToken) => {
        if (!itemToken) {
            alert("Please select an item first.");
            return;
        }

        const payload = {
            item_token: itemToken,
        };

        try {
            const res = await axios.post(`${API_ENDPOINT.get_mapped_vendors}`, payload, {
                headers: { Authorization: `Bearer ${auth_token}` },
            });
            console.log("Mapped vendors:", res.data);
            setMappedVendors(res.data);
        } catch (err) {
            console.error("Error fetching mapped vendors:", err);
            alert("Failed to fetch mapped vendors.");
        }
    };



    return (
        <div style={{ padding: "20px" }}>

            <div>

                <h1>Item Details</h1>
                <div className={classes.flex}>
                    <Autocomplete
                        options={getitem}
                        getOptionLabel={(option) => option.item_name || ""}
                        value={selectedItem}
                        onChange={(event, newValue) => {
                            setSelectedItem(newValue);
                            setItemCode(newValue?.item_code || "");
                        }}
                        isOptionEqualToValue={(option, value) => option.token === value.token}
                        renderInput={(params) => <TextField {...params} label="Select Item" variant="outlined" />}
                    />

                    <input
                        type="text"
                        value={itemCode}
                        onChange={(e) => setItemCode(e.target.value)} // Optional: if you want to allow manual edits
                        placeholder="Item Code"
                    />

                    <Autocomplete
                        options={getcategory || []}
                        getOptionLabel={(option) => option?.category_name}
                        isOptionEqualToValue={(option, value) => option.token === value.token}
                        value={selectedcategory}
                        onChange={(event, newValue) => setSelectedCategory(newValue)}
                        renderInput={(params) => (
                            <TextField {...params} label="Select Category" variant="outlined" />
                        )}
                    />
                </div>

                <div>
                    <DButtonOutlined label={"save Item"} onClick={handleSaveItem} />
                </div>
            </div>

            <div>

                <h1>Vendor Details</h1>
                <div className={classes.flex}>

                    <Autocomplete
                        options={getvendor || []}
                        getOptionLabel={(option) => option?.company_name}
                        isOptionEqualToValue={(option, value) => option.token === value.token}
                        value={selectedVendor}
                        onChange={(event, newValue) => setSelectedVendor(newValue)}
                        renderInput={(params) => (
                            <TextField {...params} label="Select Vendor" variant="outlined" />
                        )}
                    />

                    <Autocomplete
                        multiple
                        options={getcategory || []}
                        getOptionLabel={(option) => option?.category_name}
                        isOptionEqualToValue={(option, value) => option.token === value.token}
                        value={selectedvendorcategory || []}
                        onChange={(event, newValue) => setSelectedVendorCategory(newValue)}
                        renderInput={(params) => (
                            <TextField {...params} label="Select Categories" variant="outlined" />
                        )}
                    />



                </div>

                <div>
                    <DButtonOutlined label={"save vendor"} onClick={handleSaveVendor} />
                </div>
            </div>



            {/* vendor selection  */}
            <div style={{ marginTop: "40px" }}>
                <h1>Items from Item Table</h1>
                <div className={classes.flex}>
                    <Autocomplete
                        options={itemTable}
                        getOptionLabel={(option) => option?.item_name || ""}
                        isOptionEqualToValue={(option, value) => option.token === value.token}
                        value={selectedItemFromTable}
                        onChange={(event, newValue) => {
                            setSelectedItemFromTable(newValue);
                            setItemCode(newValue?.item_code || "");
                            setCategoryFromItemTable(newValue?.category_name || ""); // ✅ Set category name
                            if (newValue?.token) {
                                handleFetchVendors(newValue.token);
                            } else {
                                setMappedVendors([]);
                            }
                        }}
                        


                        renderInput={(params) => (
                            <TextField {...params} label="Select Item from Table" variant="outlined" />
                        )}
                    />


                    <input
                        type="text"
                        value={categoryFromItemTable}
                        onChange={(e) => setCategoryFromItemTable(e.target.value)} // Optional if editable
                        placeholder="Category Name"
                    />
                    <DButtonOutlined label={"Find Vendors"} onClick={handleFetchVendors} />
                </div>


                <div style={{ marginTop: "30px" }}>
                    <Typography variant="h6" gutterBottom>
                        Mapped Vendors
                    </Typography>

                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><strong>Vendor Name</strong></TableCell>
                                    <TableCell><strong>Category</strong></TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {mappedVendors.length > 0 ? (
                                    mappedVendors.map((vendor) => (
                                        <TableRow key={vendor.token}>
                                            <TableCell>{vendor.vendor_name}</TableCell>
                                            {/* <TableCell>{vendor.token}</TableCell> */}
                                            <TableCell>{vendor.category_name}</TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={3} align="center">
                                            No records found
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>


            </div>



        </div>
    )
}

export default ItemVendorMap